import { Paper, styled } from '@mui/material';

export const StyledPaper = styled(Paper)`
    width: 200px;
    height: 230px;
    overflow: auto;
    background-color: #082940;
`;
